import { APP_INITIALIZER, ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ExtraOptions, NoPreloading, Router, RouterModule, } from '@angular/router';
import { FuseModule } from '@fuse';
import { FuseConfigModule } from '@fuse/services/config';
import { CoreModule } from 'app/core/core.module';
import { appConfig } from 'app/core/config/app.config';
import { LayoutModule } from 'app/layout/layout.module';
import { EffectsModule } from '@ngrx/effects';
import { AppComponent } from 'app/app.component';
import { appRoutes } from 'app/app.routing';
import { StoreModule } from '@ngrx/store';
import * as Sentry from '@sentry/angular-ivy';
import { messagingReducer } from "./modules/messaging/store/messaging.reducer";
import { MessagingEffects } from "./modules/messaging/store/messaging.effects";
import { AppErrorHandler } from "./app.error.handler";
import { initializeApp, provideFirebaseApp } from "@angular/fire/app";
import { getFirestore, provideFirestore } from "@angular/fire/firestore/lite";
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MatNativeDateModule } from "@angular/material/core";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MAT_SNACK_BAR_DEFAULT_OPTIONS } from "@angular/material/snack-bar";
import { MomentDateAdapter } from "@angular/material-moment-adapter";

const routerConfig: ExtraOptions = {
    preloadingStrategy: NoPreloading,
    scrollPositionRestoration: 'enabled',
};

const MY_DATE_FORMAT = {
    parse: {
        dateInput: 'DD/MM/YYYY', // this is how your date will be parsed from Input
    },
    display: {
        dateInput: 'DD/MM/YYYY', // this is how your date will get displayed on the Input
        monthYearLabel: 'MMMM YYYY',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'MMMM YYYY',
    },
};


@NgModule({
    declarations: [AppComponent],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        MatNativeDateModule,
        RouterModule.forRoot(appRoutes, routerConfig),

        // Fuse, FuseConfig & FuseMockAPI
        FuseModule,
        FuseConfigModule.forRoot(appConfig),

        // Core module of your application
        CoreModule,

        // Layout module of your application
        LayoutModule,
        StoreModule.forRoot({}),
        StoreModule.forFeature('messaging', messagingReducer),
        EffectsModule.forRoot([]),
        EffectsModule.forFeature([MessagingEffects]),
    ],
    bootstrap: [AppComponent],
    providers: [
        provideFirebaseApp(() => initializeApp({
            apiKey: "AIzaSyANbJxJqb4uBU6odO_Ox67G8gB8aJB7fWM",
            authDomain: "yang-287109.firebaseapp.com",
            databaseURL: "https://yang-287109-default-rtdb.firebaseio.com",
            projectId: "yang-287109",
            storageBucket: "yang-287109.appspot.com",
            messagingSenderId: "421422163731",
            appId: "1:421422163731:web:df503f7f35fb37a91a1ce6",
        })),
        provideFirestore(() => getFirestore()),
        {
            provide: ErrorHandler,
            useClass: AppErrorHandler,
        },
        {
            provide: Sentry.TraceService,
            deps: [Router],
        },
        {
            provide: APP_INITIALIZER,
            useFactory: () => () => {
            },
            deps: [Sentry.TraceService],
            multi: true,
        },
        MatDatepickerModule,
        {
            provide: MAT_SNACK_BAR_DEFAULT_OPTIONS,
            useValue: {
                duration: 2500,
                verticalPosition: 'top',
                horizontalPosition: 'right',
                panelClass: 'custom-snack-bar',
            },
        },
        { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
        {
            provide: DateAdapter,
            useClass: MomentDateAdapter,
            deps: [MAT_DATE_LOCALE],
        },
        { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMAT },
    ],
})
export class AppModule {
}

